import { createSlice } from "@reduxjs/toolkit";

const reviewNotes = createSlice({
    name: "reviewNotes",
    initialState: [],
    reducers: {
        reset: () => { return []; },
        
        // Store options for toggling; pre-selects using resumeLater data
        setCheckableNotes: (_state, { payload }) => {
            const { config = {}, resumeLaterAdminNotes = [] } = payload ?? {};
            
            let checkableNotes = Object.values(config).flat();
            checkableNotes = JSON.parse(JSON.stringify(checkableNotes)); // Clone so we can modify
            
            resumeLaterAdminNotes.forEach(savedNote => {
                let checkableNote = checkableNotes.find(note => note.label === savedNote.label && note.section === savedNote.section);
                if (!checkableNote) { return; } // Can't find it.. maybe configuration has changed? Prevent erroring out
                checkableNote.value = true;
            });
            
            return checkableNotes;
        },

        toggleCheck: (state, { payload }) => {
            if (!payload.label) { return state; } // Invalid label

            // Flip state to match checkbox
            const note = state.find(note => note.label === payload.label);
            note.value = payload.checked;
            
            // Unchecked? If possible, uncheck all children too
            const wasUnchecked = note.value === false;
            const isPotentialParent = !note.parentLabel;
            if (!wasUnchecked || !isPotentialParent) { return; }
            
            state.forEach(childNote => childNote.parentLabel === note.label && (childNote.value = false));
        },
    }
});

// Helper functions
//
export function hasNoSiblingsSelected(note = {}, noteState, section) {
    if (!note.parentLabel) { return false; } // No parent means no siblings, solo checkable field, ignore

    const parent = noteState.find(item => item.label === note.parentLabel);
    if (!parent?.value) { return false; } // Parent checkbox is not checked, ignore

    return !noteState.filter(item => item.section === section && item.parentLabel) // Find the other subfields
        .map(item => ({ parentLabel: item.parentLabel, value: item.value }))
        .some(item => item.value); // See if at least 1 is checked
}

// Check for validation errors; returns true if there's at least 1 checked parent without a checked child
export function hasUncheckedChildren(notes = []) {
    const parents = [...new Set(notes.map(note => note.parentLabel).filter(parentLabel => parentLabel))];
    const parentsChecked = parents.filter(parent => notes.some(note => note.label === parent && note.value === true));
    const parentsWithoutCheckedChildren = parentsChecked.filter(
        parent => {
            const children = notes.filter(note => note.parentLabel === parent);
            return !children.some(note => note.value === true);
        });
    return parentsWithoutCheckedChildren.length > 0;
}

    
export function getSubmittableNotes(noteState) {
    return noteState.filter(note => note.value === true)
        .map(note => ({
                label: note.label,
                parentLabel: note.parentLabel,
                section: note.section,
        }));
}

export const selector = state => state.reviewNotes;
export const { reset, setCheckableNotes, setRestrictions, toggleCheck } = reviewNotes.actions;
export default reviewNotes.reducer;
